import validateRegister from './validateRegister';
const getValidationErrors = (state, fieldName) => {
    const registrationValidation = validateRegister(state);
    registrationValidation.passes(); // triggers the error msgs to become available
    return registrationValidation.errors.first(fieldName) || ''; // set or reset error
};
export default getValidationErrors;
